// Effect 6 — Tile pop / scale punch, staggered per letter so the word CASCADES. Each letter tile
// scales from feel.tilepop.scaleFrom down to 1.0 with easeOutBack, offset by staggerMs. This is
// the most on-theme visual for a word game: the utterance assembles itself letter by letter.
import { feel } from "../feel";
import { tween, easeOutBack } from "../anim";
import { registerEffect } from "../registry";
import { intensity, timed } from "../../tuner/scale";

export function registerTilepop(): void {
  registerEffect(
    { name: "tilepop", label: "6 · Tile pop" },
    "word:valid",
    ({ tiles }) => {
      const ease = easeOutBack(2.2);
      // intensity scales how far the tile pops past its resting size.
      const from = 1 + (feel.tilepop.scaleFrom - 1) * intensity(feel.tilepop);
      tiles.forEach((tile, i) => {
        window.setTimeout(() => {
          void tween(timed(feel.tilepop.settleMs), ease, (v) => {
            const scale = from + (1 - from) * v;
            tile.style.transform = `scale(${scale})`;
          });
        }, timed(i * feel.tilepop.staggerMs));
      });
    },
  );
}
